// extracted by mini-css-extract-plugin
export default {"files":"AttemptFiles_files__a0ybD","pagination":"AttemptFiles_pagination__EhBpq"};